import api from './api';

export interface CsApiConfig {
  is_enabled: boolean;
  has_api_key: boolean;
  api_key_masked: string;
  allowed_spops: string[];
  last_generated_at: string | null;
  api_base_url: string;
  docs_path: string;
}

export interface CsApiGenerateResult extends CsApiConfig {
  api_key: string;
}

const csApiService = {
  async getConfig(): Promise<{ success: boolean; data: CsApiConfig; message?: string }> {
    const response = await api.get('/settings/cs-api');
    return response.data;
  },

  async generateKey(): Promise<{
    success: boolean;
    data: CsApiGenerateResult;
    message?: string;
  }> {
    const response = await api.post('/settings/cs-api/generate');
    return response.data;
  },

  async updateConfig(payload: {
    is_enabled?: boolean;
    allowed_spops?: string[];
  }): Promise<{ success: boolean; data: CsApiConfig; message?: string }> {
    const response = await api.put('/settings/cs-api', payload);
    return response.data;
  },

  async revokeKey(): Promise<{ success: boolean; data: CsApiConfig; message?: string }> {
    const response = await api.post('/settings/cs-api/revoke');
    return response.data;
  },
};

export default csApiService;
